import { useContext } from "react";
import { Edit_context } from "../context/Edited-context";
export default function EditItem({inp_todo,value,id_item}) {
  let {etat,id,setEdited} = useContext(Edit_context); 
  return (
    <i className="fa-regular fa-pen-to-square edit_btn" onClick={_ => {
      inp_todo.current.value = value;
      setEdited({etat : true,id : id_item});
    }}></i>
 )
}
